import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container, H5 } from '@ui';
import { ResultOnly } from '@containers/DigitalAnalyst/components/AnswerLine';
import { Working } from '@ui/Working';
import Complete from '@ui/Complete';

const Wrapper = styled.div``;
const HeaderWrapper = styled.div`
  padding: 8px 0 8px 0;

  h5,
  p {
    padding: 0 0 0 0;
    margin: 0 0 0 0;
  }
`;
const SectionWrapper = styled.div`
  padding-top: 24px;
`;
const SectionHeading = styled.div`
  h5 {
    font-size: 16px !important;
  }
`;
const TableWrapper = styled.table`
  margin-top: 24px;
  border-radius: 4px;
  table-layout: fixed;

  th,
  td {
    border: 1px solid ${({ theme }) => theme.themeColors.text};
    padding: 4px 8px;
  }

  td {
    vertical-align: center;
    width: 120px;
  }
`;

const TextAnswer = ({ answers, templateKey }) => {
  const answerValue = answers[templateKey] || null;

  if (answerValue === null) return <Body5>Working...</Body5>;

  return <ResultOnly result={answerValue} />;
};

export const PortfolioSnapshot = ({ answers, selectedDocs, isStreamComplete }) => {
  if (!answers) {
    return null;
  }

  if (!isStreamComplete) {
    return (
      <Container top={80} bottom={80} centerAll>
        <Container fullWidth>
          <Working />
        </Container>
      </Container>
    );
  }
  return (
    <Container top={24}>
      <Complete />
    </Container>
  );

  //   const onQueryDocumentsClick = () => {
  //     const url = ROUTES.digitalAnalyst + `?doc-ids=${selectedDocs.map((d) => d.id).join(',')}`;
  //     window.open(url, '_blank');
  //   };

  return (
    <Wrapper>
      <HeaderWrapper>
        <Container row verticallyCenter spaceBetween>
          <H5 uppercase>Portfolio Snapshot</H5>
          {/* <Container left={8}>
            <SkeletonButton onClick={onQueryDocumentsClick}>Query Documents</SkeletonButton>
          </Container> */}
        </Container>
        <Container top={16}>
          <TextAnswer answers={answers} templateKey={'{{TEMPLATE_1}}'} />
          &nbsp;&nbsp;&nbsp;
          <TextAnswer answers={answers} templateKey={'{{TEMPLATE_2}}'} />
        </Container>
      </HeaderWrapper>

      <SectionWrapper>
        <SectionHeading>
          <Body1>
            <u>Fund Performance (Net)</u>
          </Body1>
        </SectionHeading>

        <Container top={16}>
          <TableWrapper>
            <thead>
              <tr>
                <th colSpan={2}>
                  <Body5>
                    <b>Year</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>Q1</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>Q2</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>Q3</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>Q4</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>YTD/Total</b>
                  </Body5>
                </th>
                <th>
                  <Body5>
                    <b>YTD/Total Annualized</b>
                  </Body5>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={2}>
                  <Body5>2023</Body5>
                </td>
                <td>
                  <Body5>Unlevered</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_3}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_9}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_15}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_21}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_27}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_33}}'} />
                </td>
              </tr>
              <tr>
                <td>
                  <Body5>Actual Net</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_4}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_10}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_16}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_22}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_28}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_34}}'} />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>
                  <Body5>2024</Body5>
                </td>
                <td>
                  <Body5>Unlevered</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_5}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_11}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_17}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_23}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_29}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_35}}'} />
                </td>
              </tr>
              <tr>
                <td>
                  <Body5>Actual Net</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_6}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_12}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_18}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_24}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_30}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_36}}'} />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>
                  <Body5>2025</Body5>
                </td>
                <td>
                  <Body5>Unlevered</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_7}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_13}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_19}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_25}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_31}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_37}}'} />
                </td>
              </tr>
              <tr>
                <td>
                  <Body5>Actual Net</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_8}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_14}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_20}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_26}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_32}}'} />
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_38}}'} />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>
                  <Body5>Since Inception</Body5>
                </td>
                <td>
                  <Body5>Unlevered</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_39}}'} />
                </td>
              </tr>
              <tr>
                <td>
                  <Body5>Actual Net</Body5>
                </td>
                <td>
                  <TextAnswer answers={answers} templateKey={'{{Template_40}}'} />
                </td>
              </tr>
            </tbody>
          </TableWrapper>
        </Container>

        <Container top={16}>
          <Body5>
            <b>Note:</b> Net returns and net IRR are calculated based on cash inflows to the Fund and the Fund net asset
            value, after the deduction of all fees and expenses in connection with the Fund, including fees paid to the
            Investment Manager and Carried Interest allocable to the General Partner, as of that period end. Quarterly
            and YTD/Total figures represent the absolute return of the applicable period, while YTD/Total Annualized and
            Since Inception figures are calculated on an annualized basis. Contributions are deemed to have been
            received on the requested contribution date. Note the prior Quarterly Investment Reports presented
            performance figures before Carried Interest allocable to the General Partner
          </Body5>
        </Container>
      </SectionWrapper>
    </Wrapper>
  );
};
